export default {

  title: '后台管理系统',

  // 站点品牌展示：配置了 siteLogo 显示图片，siteLogo 为空时显示 siteTitle 文字
  siteLogo: require('../assets/site-logo.png'),
  siteTitle: '卡西欧官方商城',
  loginBackground: require('../assets/login/background.png'),
  qrcodes: [
  ],
  copyright: '卡西欧官方商城',
  icp: '京ICP备 10009123号-10',
  customerService: {
    tel: '400-700-6655',
    time: '(周一至周日 9:00-21:00)'
  },

  api: {
    baseURL: 'http://localhost:8000/web'
  },

  client: {
    web: {
      baseUrl: 'http://localhost:8080',
    },
    admin: {
      baseUrl: 'http://localhost:8081',
    },
  },

  payMethod: {
    aliPay: true,
    wxPay: true
  }
}
